module.exports = __webpack_public_path__ + "img/pr-4.32f0184e.png";